import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersBarComponent } from './ui/filters-bar/filters-bar.component';
import { GlobalFiltersComponent } from './ui/global-filters/global-filters.component';
import { SharedModule } from '../../../shared/shared.module';
import { FilterExportsPageComponent } from './ui/filter-exports-page/filter-exports-page.component';
import { ThemeModule } from '@ex/module/shared/Theme/theme.module';



@NgModule({
  declarations: [
    FiltersBarComponent,
    GlobalFiltersComponent,
    FilterExportsPageComponent,

  ],
  imports: [
    CommonModule,
    ThemeModule
  ],
  exports: [
    FiltersBarComponent,
    GlobalFiltersComponent,
    FilterExportsPageComponent
  ]
})
export class GlobalFiltersModule { }
